

const PeerOnlineStatus = {
	online: 'online',
	offline: 'offline',
	unReachable: 'unReachable'
}

const AppKey = {
	AgoraAppKey: '293968ad3083492091a779d912310a4e'
}

const AgoraEventName = {
	ConnectionStateChanged: 'ConnectionStateChanged',
	MessageFromPeer: 'MessageFromPeer',
	LocalInvitationAccepted: 'LocalInvitationAccepted',
	LocalInvitationFailure: 'LocalInvitationFailure',
	LocalInvitationRefused: 'LocalInvitationRefused',
	LocalInvitationCanceled: 'LocalInvitationCanceled',
	LocalInvitationReceivedByPeer: 'LocalInvitationReceivedByPeer',
	PeersOnlineStatusChanged: 'PeersOnlineStatusChanged',

	RemoteInvitationReceived: 'RemoteInvitationReceived',
	RemoteInvitationCanceled: 'RemoteInvitationCanceled',
	RemoteInvitationAccepted: 'RemoteInvitationAccepted',
	RemoteInvitationRefused: 'RemoteInvitationRefused',
	RemoteInvitationFailure: 'RemoteInvitationFailure',

	StreamPublished: 'stream-published',
	StreamAdded: 'stream-added',
	StreamSubscribed: 'stream-subscribed',
	PeerLeave: 'peer-leave',

	onLoginSuccess: 'onLoginSuccess',
	onLoginFailed: 'onLoginFailed',
	onError: 'onError',
	onLogout: 'onLogout',
	onQueryUserStatusResult: 'onQueryUserStatusResult',
	onMessageInstantReceive: 'onMessageInstantReceive',
	onMessageSendSuccess: 'onMessageSendSuccess',
	onMessageSendError: 'onMessageSendError',
	onInviteReceived: 'onInviteReceived',
	onInviteReceivedByPeer: 'onInviteReceivedByPeer',
	onInviteRefusedByPeer: 'onInviteRefusedByPeer',
	onInviteEndByPeer: 'onInviteEndByPeer',
	onInviteAcceptedByPeer: 'onInviteAcceptedByPeer',
	onChannelLeaved: 'onChannelLeaved',
	muteAudio: 'mute-audio',
	unmuteAudio: 'unmute-audio',
	muteVideo: 'mute-video',
	unmuteVideo: 'unmute-video'

}

const MessageContentType = {
	text: 'txt',
	png: 'png',
	jpg: 'jpg',
	jpeg: 'jpeg',
	bmp: 'bmp',
	pdf: 'pdf',
	footer: 'footer'
}

const ChatType = {
	chatList: 0,
	makingCall: 1,
	gettingCall: 2,
	videoChat: 3,
}

const MobileChatType = {
	consent: 0,
	invite: 1,
	canCall: 2,
	makeCall: 3,
	receiveCall: 4,
	video: 5,
}

const ChatMessageStatusType = {
	finish: 0,
	loading: 1,
	fail: 2,
}

const BrowserEventName = {
	beforeunload: 'beforeunload',
	onunload: 'onunload',
	onbeforeunload: 'onbeforeunload'
}

const PeerMessageSendResult = {
	success: 0,
	peerOffline: 1,
	fail: 2,
}

const ChatRoomJoinStatus = {
	canNotJoin: 0,
	canJoin: 1,
}

const Language = {
	english: 'English',
	chinese: 'Chinese',
	spanish: 'Spanish',
}

const PlatformType = {
	iOS: 'iOS',
	android: 'Android',
	macOS: 'Mac OS',
	windows: 'Windows',
	linux: 'linux',
	iPad: 'iPad'
}

const RTMConnectState = {
	aborted: 'ABORTED',
	connected: 'CONNECTED',
	connecting:'CONNECTING',
	disconnected:'DISCONNECTED',
	reconnecting:'RECONNECTING',
}

const MeetingRole = {
	patient: 0,
	doctor: 1,
}

export {
	AgoraEventName,
	ChatType,
	ChatMessageStatusType,
	AppKey,
	MessageContentType,
	PeerOnlineStatus,
	BrowserEventName,
	PeerMessageSendResult,
	ChatRoomJoinStatus,
	Language,
	PlatformType,
	MobileChatType,
	RTMConnectState,
	MeetingRole
}
